module.exports = require('./src/objektiv');



//////////////////
// WEBPACK FOOTER
// ./~/objektiv/index.js
// module id = 1674
// module chunks = 2